/**
 * Composable pour restaurer la position de scroll après navigation
 * Utilisé avec keepalive pour préserver l'état de défilement
 *
 * @param key - Identifiant unique pour la page/composant
 */
export function useScrollRestore(key: string) {
  // Store global pour les positions de scroll
  const scrollPositions = useState<Record<string, number>>('scroll-positions', () => ({}))

  // Sauvegarder la position avant désactivation
  onDeactivated(() => {
    if (import.meta.client) {
      scrollPositions.value[key] = window.scrollY
    }
  })

  // Restaurer la position après réactivation
  onActivated(() => {
    if (import.meta.client) {
      const savedPosition = scrollPositions.value[key]
      if (savedPosition !== undefined) {
        // Utiliser nextTick pour s'assurer que le DOM est rendu
        nextTick(() => {
          window.scrollTo(0, savedPosition)
        })
      }
    }
  })

  // Fonction manuelle pour sauvegarder la position (ex: avant navigation)
  function saveScrollPosition() {
    if (import.meta.client) {
      scrollPositions.value[key] = window.scrollY
    }
  }

  // Fonction pour réinitialiser la position (ex: après reset filtres)
  function resetScrollPosition() {
    if (import.meta.client) {
      scrollPositions.value = Object.fromEntries(
        Object.entries(scrollPositions.value).filter(([k]) => k !== key),
      )
      window.scrollTo(0, 0)
    }
  }

  return {
    saveScrollPosition,
    resetScrollPosition,
  }
}
